var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowerAbdomen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "20px",
    viewBox: "0 0 55 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Lower Abdomen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-37",
    transform: "translate(-188.000000, -173.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front-Body---Selections",
    transform: "translate(175.074098, 42.681852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.6147082,130.318148 C66.1514658,133.346316 66.5562733,135.726972 66.8291305,137.460115 C67.1019878,139.193259 67.4559879,141.812603 67.8911309,145.318148 C59.6220156,142.527241 52.4494702,144.018001 46.3734947,149.790428 C45.3658423,147.156243 43.0819065,145.318148 40.425902,145.318148 C37.8643084,145.318148 35.6488024,147.027891 34.5897728,149.512313 C28.6542676,144.186063 21.5322999,142.78798 13.224895,145.318148 L14.0134668,140.391116 L15.5698894,130.318148 L65.6147082,130.318148 Z",
    id: "Lower-Abdomen"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerAbdomen);
export default __webpack_public_path__ + "static/media/LowerAbdomen.f253194e6d276129bf27073a0b2525b2.svg";
export { ForwardRef as ReactComponent };